/* eslint-disable no-param-reassign */
const Tabs = function (config, Alpine) {
  const addActiveClass = (elements) => {
    if (elements.length > 0) {
      elements[0].classList.add("active");
    }
  };

  const removeActiveClass = (elements, target) => {
    elements.forEach((element) => {
      if (element !== target) {
        element.classList.remove("active");
      }
    });
  };

  const handleTabClick = (tabLinks, tabContentHolder) => (e) => {
    e.preventDefault();

    const currentTab = e.currentTarget;

    tabLinks.forEach((tabLink) => {
      if (tabLink !== currentTab) {
        tabLink.classList.remove("active");
      }
    });

    currentTab.classList.add("active");

    if (currentTab.classList.contains("active")) {
      const targetUrl = currentTab.getAttribute("href").replace(/\s+/g, "");
      const target = document.querySelector(targetUrl);

      removeActiveClass(tabContentHolder, target);
      target.classList.add("active");
    }
  };

  const tabAction = () => {
    const categoryTab = document.querySelectorAll(".js-category-tab");
    const categoryHolder = document.querySelectorAll(".js-category-content-holder");
    const tabLinks = document.querySelectorAll(".js-tabset-link");
    const tabContentHolder = document.querySelectorAll(".tab-content--holder");

    addActiveClass(tabContentHolder);
    addActiveClass(categoryHolder);
    addActiveClass(tabLinks);
    addActiveClass(categoryTab);

    tabLinks.forEach((tabLink) => {
      tabLink.addEventListener("click", handleTabClick(tabLinks, tabContentHolder));
    });

    categoryTab.forEach((categoryLink) => {
      categoryLink.addEventListener("click", handleTabClick(categoryTab, categoryHolder));
    });
  };

  this.init = function () {
    tabAction();
  };
};

export default Tabs;
